webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      isMenuActive: false,
      urlTermsAndPrivacy: this.$helpers.urlMainWebsite + '/terms-and-privacy'
    };
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.isMenuActive = !this.isMenuActive;
    }
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Banner__ = __webpack_require__(83);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mainView',
  components: {
    Banner: __WEBPACK_IMPORTED_MODULE_0__Banner__["a" /* default */]
  },
  data: function data() {
    return {
      orgCode: '',
      isLoading: false,
      error: {
        orgCode: this.msgOrgCode
      }
    };
  },

  methods: {
    isOrgCodeValid: function isOrgCodeValid() {
      if (this.$helpers.isOrgCode(this.orgCode)) {
        this.error.orgCode = '';
        return true;
      }
      this.error.orgCode = this.msgOrgCode;
      return false;
    },
    next: function next() {
      var _this = this;

      if (!this.isOrgCodeValid()) {
        return;
      }
      this.isLoading = true;
      this.$http.post('/scarf/createSession', {
        orgCode: this.orgCode
      }).then(function (res) {
        _this.isLoading = false;
        if (res.data.ok === 1) {
          console.log('scarf session id:', res.data.sessionCode);
          _this.$temp.sessionCode = res.data.sessionCode;
          _this.$toast.open('Your session is created');
          _this.$router.push('language-selection');
        } else {
          _this.$toast.open(res.data.msg);
        }
      });
    }
  },
  watch: {
    orgCode: function orgCode(val) {
      if (this.$helpers.isOrgCode(val)) {
        this.error.orgCode = '';
        return;
      }
      this.error.orgCode = this.msgOrgCode;
    }
  },
  computed: {
    msgOrgCode: function msgOrgCode() {
      return 'Enter valid access code';
    }
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImageC__ = __webpack_require__(85);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'banner',
  props: {
    imageSmall: String,
    imageLarge: String,
    paddingBottom: String,
    title: String,
    desc: String
  },
  components: {
    ImageC: __WEBPACK_IMPORTED_MODULE_0__ImageC__["a" /* default */]
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'imageC',
  props: {
    imageSmall: String,
    imageLarge: String,
    paddingBottom: String // aspect ratio percent
  },
  data: function data() {
    return {
      isSmallLoaded: false,
      isLargeLoaded: false
    };
  },

  methods: {
    setSmall: function setSmall() {
      this.isSmallLoaded = true;
    },
    setLarge: function setLarge() {
      this.isLargeLoaded = true;
    },
    getPadding: function getPadding() {
      return 'padding-bottom: ' + this.paddingBottom + ';';
    }
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'englishConsentForm',
  data: function data() {
    return {
      title: 'Consent Form',
      agreed: false,
      disagreed: false,
      reasonForDecline: '',
      declineMsg: 'Thanks for your feedback.',
      isFeedbackSend: false
    };
  },

  methods: {
    next: function next() {
      if (this.agreed) {
        this.$router.push('demographics/english');
      }
    },
    decline: function decline() {
      var _this = this;

      if (this.reasonForDecline === '') {
        this.$toast.open('Please provide reason for disagreeing');
        return;
      }
      this.$http.post('/scarf/declineTest', {
        sessionId: this.$temp.sessionCode,
        reason: this.reasonForDecline
      }).then(function (res) {
        if (res.data.ok === 1) {
          _this.$toast.open(_this.declineMsg);
          _this.isFeedbackSend = true;
        }
      });
    }
  },
  created: function created() {
    window.scroll(0, 0);
    console.log('general info created');
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SessionInfo__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Demographics',
  components: {
    SessionInfo: __WEBPACK_IMPORTED_MODULE_0__SessionInfo__["a" /* default */]
  },
  data: function data() {
    return {
      isLoading: true,
      isLoadingSubmit: false,
      isResponseSubmitted: false,
      demographicQues: [],
      questionIndex: 0,
      responses: [],
      testId: { english: 1, tamil: 4, hindi: 5 },
      options: [],
      errors: [],
      language: 'english' // default
    };
  },

  methods: {
    next: function next() {
      this.$router.push('/tests/English');
      console.log(this.responses);
    },
    isMandatoryField: function isMandatoryField(qIndex) {
      // 1st 4 are mandatory
      for (var i = 0; i < 4; i += 1) {
        if (qIndex === i) {
          return true;
        }
      }
      return false;
    },
    updateOption: function updateOption(index, qIndex) {
      if (this.options[qIndex] !== undefined) {
        var prevOption = this.options[qIndex];
        console.log('prev option : ', prevOption);
        document.getElementById(qIndex + 'Res' + prevOption).classList.remove('active');
      }
      document.getElementById(qIndex + 'Res' + index).classList.add('active');
      this.responses[qIndex] = { idx: index };
      this.options[qIndex] = index;
    },
    isFieldsValid: function isFieldsValid(value) {
      var qInfo = JSON.parse(this.demographicQues[this.questionIndex].qInfo);
      // debugger;
      // no validation (i.e. fields valid by default) if qInfo is not given (null, undefined or '')
      if (!!qInfo === false) {
        return true;
      }
      var vObj = new RegExp(qInfo.vReg);
      var isValid = vObj.test(value);
      console.log('isValid:', vObj, value, isValid);
      if (isValid) {
        this.errors.splice(this.questionIndex, 1, '');
        return true;
      }

      this.errors.splice(this.questionIndex, 1, qInfo.err);
      return false;
    },
    updateText: function updateText(index, qIndex, value) {
      this.questionIndex = qIndex;
      this.isFieldsValid(value);
      this.responses[qIndex] = { text: value };
    },
    isEmpty: function isEmpty(value) {
      return value === undefined || value === '';
    },
    isResponseCompleted: function isResponseCompleted() {
      for (var i = 0; i < 4; i += 1) {
        this.questionIndex = i;
        if (this.responses[i] === undefined) {
          return false;
        }
        if (!this.isFieldsValid(this.responses[i].text)) {
          return false;
        }
      }
      return true;
    },
    setResponseNotSaved: function setResponseNotSaved() {
      for (var i = 4; i <= 7; i += 1) {
        if (this.isEmpty(this.responses[i])) {
          this.responses[i] = { idx: -1 };
        }
      }
    },
    sendRequest: function sendRequest() {
      var _this = this;

      console.log(this.responses);
      if (this.responses.length < 4 || !this.isResponseCompleted()) {
        this.$toast.open('Please fill ALL mandatory fields indicated by "*"');
        return;
      }
      this.setResponseNotSaved();
      this.isLoadingSubmit = true;
      this.$http.post('/scarf/submitAnswers', {
        sessionCode: this.$temp.sessionCode,
        testId: this.testId[this.language],
        responses: this.responses
      }).then(function (res) {
        _this.isLoadingSubmit = false;
        if (res.data.ok === 1) {
          _this.$toast.open(res.data.msg);
          _this.isResponseSubmitted = true;
        } else {
          _this.$toast.open(res.data.msg);
          _this.isResponseSubmitted = false;
        }
      });
    },
    checkSessionAndInit: function checkSessionAndInit() {
      if (this.$temp.sessionCode) {
        this.getDemoQuestions();
      } else {
        this.$toast.open('Your session ended. Enter your organization code and try again.');
        this.$router.push('/');
      }
    },
    getDemoQuestions: function getDemoQuestions() {
      var _this2 = this;

      console.log('qId', this.language, this.testId[this.language]);
      this.$http.get('/scarf/getQuestions', {
        params: {
          qId: this.testId[this.language]
        }
      }).then(function (res) {
        console.log('ques:', res.data);
        _this2.isLoading = false;
        _this2.demographicQues = res.data.questions;
      });
    }
  },
  watch: {
    option: function option(value) {
      this.isFieldsValid(value);
    }
  },
  created: function created() {
    window.scroll(0, 0);
    this.language = this.$route.params.language;
    console.log('language', this.language);
    this.checkSessionAndInit();
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SessionInfo_vue__ = __webpack_require__(24);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b34059_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SessionInfo_vue__ = __webpack_require__(96);
function injectStyle (ssrContext) {
  __webpack_require__(95)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52b34059"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SessionInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b34059_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SessionInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sessionInfo',
  data: function data() {
    return {
      userId: this.$temp.sessionCode,
      testId: +this.$temp.testId
    };
  },

  methods: {}
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tamilConsentForm',
  data: function data() {
    return {
      title: 'Consent Form',
      agreed: false,
      disagreed: false,
      reasonForDecline: '',
      declineMsg: 'Thanks for your feedback.',
      isFeedbackSend: false
    };
  },

  methods: {
    next: function next() {
      if (this.agreed) {
        this.$router.push('demographics/tamil');
      }
    },
    decline: function decline() {
      var _this = this;

      if (this.reasonForDecline === '') {
        this.$toast.open('Please provide reason for disagreeing');
        return;
      }
      this.$http.post('/scarf/declineTest', {
        sessionId: this.$temp.sessionCode,
        reason: this.reasonForDecline
      }).then(function (res) {
        if (res.data.ok === 1) {
          _this.$toast.open(_this.declineMsg);
          _this.isFeedbackSend = true;
        }
      });
    }
  },
  created: function created() {
    window.scroll(0, 0);
    console.log('general info created');
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hindiConsentForm',
  data: function data() {
    return {
      title: 'Consent Form',
      agreed: false,
      disagreed: false,
      reasonForDecline: '',
      declineMsg: 'Thanks for your feedback.',
      isFeedbackSend: false
    };
  },

  methods: {
    next: function next() {
      if (this.agreed) {
        this.$router.push('demographics/hindi');
      }
    },
    decline: function decline() {
      var _this = this;

      if (this.reasonForDecline === '') {
        this.$toast.open('Please provide reason for disagreeing');
        return;
      }
      this.$http.post('/scarf/declineTest', {
        sessionId: this.$temp.sessionCode,
        reason: this.reasonForDecline
      }).then(function (res) {
        if (res.data.ok === 1) {
          _this.$toast.open(_this.declineMsg);
          _this.isFeedbackSend = true;
        }
      });
    }
  },
  created: function created() {
    window.scroll(0, 0);
    console.log('general info created');
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'marathiConsentForm',
  data: function data() {
    return {
      title: 'Consent Form',
      agreed: false,
      disagreed: false,
      reasonForDecline: '',
      declineMsg: 'Thanks for your feedback.',
      isFeedbackSend: false
    };
  },

  methods: {
    next: function next() {
      if (this.agreed) {
        this.$router.push('demographics/marathi');
      }
    },
    decline: function decline() {
      var _this = this;

      if (this.reasonForDecline === '') {
        this.$toast.open('Please provide reason for disagreeing');
        return;
      }
      this.$http.post('/scarf/declineTest', {
        sessionId: this.$temp.sessionCode,
        reason: this.reasonForDecline
      }).then(function (res) {
        if (res.data.ok === 1) {
          _this.$toast.open(_this.declineMsg);
          _this.isFeedbackSend = true;
        }
      });
    }
  },
  created: function created() {
    window.scroll(0, 0);
    console.log('general info created');
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'englishParticipationInfo',
  data: function data() {
    return {
      title: 'Participant Information'
    };
  },
  created: function created() {
    window.scroll(0, 0);
    console.log('general info created');
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tamilParticipationInfo',
  methods: {
    next: function next() {
      this.$router.push('demographics');
    }
  },
  created: function created() {
    window.scroll(0, 0);
    console.log('general info created');
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hindiParticipationInfo',
  data: function data() {
    return {
      title: 'Participant Information'
    };
  },
  created: function created() {
    window.scroll(0, 0);
    console.log('general info created');
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'marathiParticipationInfo',
  data: function data() {
    return {
      title: 'Participant Information'
    };
  },
  created: function created() {
    window.scroll(0, 0);
    console.log('general info created');
  }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__ = __webpack_require__(33);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d6a63c3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__ = __webpack_require__(120);
function injectStyle (ssrContext) {
  __webpack_require__(119)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d6a63c3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d6a63c3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SessionInfo__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'summary-info',
  components: {
    SessionInfo: __WEBPACK_IMPORTED_MODULE_0__SessionInfo__["a" /* default */]
  },
  props: {
    response: Array,
    question: Array
  },
  data: function data() {
    return {
      isResultSubmitted: false,
      userId: this.$temp.sessionCode,
      testId: +this.$temp.testId,
      isLoadingSubmit: false,
      showResults: false
    };
  },

  methods: {
    checkResults: function checkResults() {
      this.$router.push('/results');
    },
    submitYourResponse: function submitYourResponse() {
      var _this = this;

      this.isLoadingSubmit = true;
      this.$http.post('/scarf/submitAnswers', {
        sessionCode: this.userId,
        testId: this.testId,
        responses: this.response
      }).then(function (res) {
        _this.isLoadingSubmit = false;
        if (res.data.ok === 1) {
          _this.$toast.open(res.data.msg);
          _this.isResultSubmitted = true;
        } else {
          _this.$toast.open(res.data.msg);
          _this.isResultSubmitted = false;
        }
      });
    }
  },
  created: function created() {
    if (!this.$temp.sessionCode) {
      this.$toast.open('Your session ended. Enter your organization code and try again.');
      this.$router.push('/');
    }
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Summary__ = __webpack_require__(32);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tests',
  components: {
    Summary: __WEBPACK_IMPORTED_MODULE_0__Summary__["a" /* default */]
  },
  data: function data() {
    return {
      index: 0,
      isLoading: true,
      progressPercent: 0,
      questions: [],
      question: '',
      options: [],
      quesInfo: '',
      responses: [],
      questionairAttended: false,
      isSubQuestion: false,
      subOptions: [],
      subQuestion: ''
    };
  },

  methods: {
    setInitialQuesOptions: function setInitialQuesOptions() {
      this.question = this.questions[0].question;
      this.options = this.questions[0].options;
      this.quesInfo = this.questions[0].qInfo;
    },
    setQuestionsDatas: function setQuestionsDatas(index) {
      this.question = this.questions[index].question;
      this.options = this.questions[index].options;
      this.quesInfo = this.questions[index].qInfo;
    },
    setNextQuesAndOptions: function setNextQuesAndOptions(index) {
      this.index = index;
      this.setQuestionsDatas(this.index);
      this.updateProgress();
      this.scrollToQuestion();
    },
    fetchQuestions: function fetchQuestions() {
      var _this = this;

      this.$http.get('/scarf/getQuestions', {
        params: { qId: this.$temp.testId }
      }).then(function (res) {
        _this.isLoading = false;
        _this.questions = res.data.questions;
        console.log(_this.questions);
        _this.setInitialQuesOptions();
      });
    },
    updateProgress: function updateProgress() {
      var progress = 100 * this.index / this.questions.length;
      this.progressPercent = parseInt(progress, 10);
    },
    scrollToQuestion: function scrollToQuestion() {
      window.scroll(0, 0);
    },
    showQuestion: function showQuestion(index) {
      console.log('question: ', index);
      if (index < 0) {
        return;
      }
      if (index >= this.questions.length) {
        this.questionairAttended = true;
        return;
      }
      this.setNextQuesAndOptions(index);
    },
    isOddIndex: function isOddIndex(index) {
      if (index % 2 === 0) {
        return false;
      }
      return true;
    },
    showPrevQuesOptions: function showPrevQuesOptions(index) {
      if (index < 0) {
        return;
      }
      if (index >= this.questions.length) {
        this.questionairAttended = true;
        return;
      }
      this.index = index;
      if (this.index > 15 && this.isOddIndex(this.index)) {
        if (this.responses[this.index - 1].idx === 0) {
          this.index = index - 1;
          this.isSubQuestion = false;
          this.setQuestionsDatas(this.index);
        } else {
          this.setQuestionsDatas(this.index - 1);
          this.isSubQuestion = true;
          this.subQuestion = this.questions[this.index].question;
          this.subOptions = this.questions[this.index].options;
        }
      } else {
        this.isSubQuestion = false;
        this.setQuestionsDatas(this.index);
      }
      this.updateProgress();
      this.scrollToQuestion();
    },
    updateResponse: function updateResponse(optionIndex) {
      this.responses[this.index] = { idx: optionIndex };
      if (this.index + 1 < this.questions.length) {
        if (this.index > 15 && this.isOddIndex(this.index + 1)) {
          if (optionIndex === 0) {
            this.index = this.index + 1;
            this.isSubQuestion = false;
            this.responses[this.index] = { idx: 0 };
          } else {
            console.log('subquestion');
            this.isSubQuestion = true;
            this.subQuestion = this.questions[this.index + 1].question;
            this.subOptions = this.questions[this.index + 1].options;
            return;
          }
        }
      }
      this.showQuestion(this.index + 1);
      console.log(this.responses);
    },
    updateResponseSubQuestion: function updateResponseSubQuestion(optionIndex) {
      this.isSubQuestion = false;
      this.index = this.index + 1;
      this.responses[this.index] = { idx: optionIndex };
      this.showQuestion(this.index + 1);
      console.log(this.responses);
    }
  },
  created: function created() {
    if (this.$temp.sessionCode) {
      this.fetchQuestions();
    } else {
      this.$toast.open('Your session ended. Enter your organization code and try again.');
      this.$router.push('/');
    }
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Results_vue__ = __webpack_require__(36);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d06eb64_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Results_vue__ = __webpack_require__(125);
function injectStyle (ssrContext) {
  __webpack_require__(124)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d06eb64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Results_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d06eb64_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Results_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'results',
  data: function data() {
    return {
      testResults: [],
      isLoading: true,
      testId: parseInt(this.$temp.testId, 10),
      sessionCode: this.$temp.sessionCode
    };
  },

  methods: {
    getResult: function getResult() {
      var _this = this;

      this.$http.post('/scarf/getResults', {
        testId: this.testId,
        sessionCode: this.sessionCode
      }).then(function (res) {
        if (res.data.ok === 1) {
          console.log('Results:', res.data);
          _this.testResults = res.data;
          _this.isLoading = false;
          _this.$temp.endSession();
        } else {
          _this.$toast.open(res.data.msg);
        }
      });
    }
  },
  created: function created() {
    this.getResult();
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Results__ = __webpack_require__(35);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checkResults',
  components: {
    Results: __WEBPACK_IMPORTED_MODULE_0__Results__["a" /* default */]
  },
  data: function data() {
    return {
      sessionCode: '',
      isTestResultVisible: false,
      isLoading: false,
      languageId: 0,
      error: {
        sessionCode: this.msgSessionCode,
        language: this.msgLanguage
      },
      testResults: undefined,
      canGetResult: true,
      languages: [{ id: 2, name: 'English' }, { id: 3, name: 'Tamil' }, { id: 6, name: 'Hindi' }]
    };
  },

  methods: {
    isSessionCodeValid: function isSessionCodeValid() {
      if (this.$helpers.isOrgCode(this.sessionCode)) {
        this.error.sessionCode = '';
        return true;
      }
      this.error.sessionCode = this.msgSessionCode;
      return false;
    },
    isLanguageValid: function isLanguageValid() {
      if (this.languageId !== 0) {
        this.error.language = '';
        return true;
      }
      this.error.language = this.msgLanguage;
      return false;
    },
    getSession: function getSession() {
      var _this = this;

      if (!this.isSessionCodeValid()) {
        return;
      }
      if (!this.isLanguageValid()) {
        return;
      }
      this.isLoading = true;
      this.$http.post('/scarf/getSession', {
        sessionCode: this.sessionCode,
        params: { testId: this.languageId }
      }).then(function (res) {
        _this.isLoading = false;
        if (res.data.ok === 1) {
          console.log(res.data.status.isDemoDone);
          _this.$temp.sessionCode = _this.sessionCode;
          _this.$temp.testId = _this.languageId;
          if (res.data.status.isDemoDone && res.data.status.isTestsDone) {
            _this.isTestResultVisible = true;
            _this.canGetResult = false;
            return;
          }
          if (res.data.status.isDemoDone === false) {
            _this.$toast.open('Please attend the demographic questions.');
            _this.$router.push('language-selection');
          } else if (res.data.status.isTestsDone === false) {
            _this.$toast.open('Please take the test.');
            if (_this.languageId === 2) {
              _this.$router.push('/tests/English');
            } else if (_this.languageId === 3) {
              _this.$router.push('/tests/Tamil');
            } else if (_this.languageId === 4) {
              _this.$router.push('/tests/Hindi');
            } else if (_this.languageId === 5) {
              _this.$router.push('/tests/Marathi');
            }
          }
        } else {
          _this.$toast.open(res.data.msg);
        }
      });
    }
  },
  watch: {
    sessionCode: function sessionCode(val) {
      if (this.$helpers.isOrgCode(val)) {
        this.error.sessionCode = '';
        return;
      }
      this.error.sessionCode = this.msgSessionCode;
    },
    language: function language() {
      if (this.LanguageName !== '') {
        this.error.Language = '';
        return;
      }
      this.error.language = this.msgLanguage;
    }
  },
  computed: {
    msgSessionCode: function msgSessionCode() {
      return 'Enter valid Result Id/Session Code';
    },
    msgLanguage: function msgLanguage() {
      return 'Select a Language';
    }
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'languageSelection',
  data: function data() {
    return {
      isLoadingEnglish: false,
      isLoadingTamil: false,
      isLoadingHindi: false,
      isLoadingMarathi: false
    };
  },

  methods: {
    sendRequest: function sendRequest(language) {
      if (language === 'English') {
        this.$router.push('consent-form-english');
        this.$temp.testId = 2;
      } else if (language === 'Hindi') {
        this.$router.push('consent-form-hindi');
        this.$temp.testId = 6;
      } else if (language === 'Marathi') {
        this.$router.push('consent-form-marathi');
        this.$temp.testId = 5;
      } else {
        this.$router.push('consent-form-tamil');
        this.$temp.testId = 3;
      }
    }
  },
  created: function created() {
    window.scroll(0, 0);
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      isLoading: false,
      isReset: false,
      msgLoginError: '',
      error: {
        alias: this.msgAlias,
        password: this.msgPassword
      },
      alias: '',
      password: ''
    };
  },

  methods: {
    resetFields: function resetFields() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.isReset = true;
    },
    isAliasValid: function isAliasValid() {
      if (this.$helpers.isAlias(this.alias)) {
        this.error.alias = '';
        return true;
      }
      this.error.alias = this.msgAlias;
      return false;
    },
    isPasswordValid: function isPasswordValid() {
      if (this.$helpers.isPassword(this.password)) {
        this.error.password = '';
        return true;
      }
      this.error.password = this.msgPassword;
      return false;
    },
    isLoginValid: function isLoginValid() {
      return this.isAliasValid() && this.isPasswordValid();
    },
    submitLogin: function submitLogin() {
      var _this = this;

      if (!this.isLoginValid()) {
        return;
      }
      this.isLoading = true;
      this.$http.post('/scarf/login', {
        alias: this.alias,
        pass: this.password
      }).then(function (res) {
        _this.isLoading = false;
        console.log('Login res:', res.data);
        // Wrong credentials. Access denied.
        _this.resetFields();
        if (res.data.ok === 1) {
          _this.$user.token = res.data.token;
          _this.$user.user = res.data.user;
          _this.$router.push('data');
        } else {
          _this.msgLoginError = res.data.msg;
        }
      });
    }
  },
  watch: {
    alias: function alias(val) {
      if (this.$helpers.isAlias(val)) {
        this.error.alias = '';
        return;
      }
      this.error.alias = this.msgAlias;
    },
    password: function password(val) {
      if (this.$helpers.isPassword(val)) {
        this.error.password = '';
        return;
      }
      this.error.password = this.msgPassword;
    }
  },
  computed: {
    msgAlias: function msgAlias() {
      if (this.isReset) {
        return '';
      }
      return 'Minimum 5 characters. Only alphabets and numbers.';
    },
    msgPassword: function msgPassword() {
      if (this.isReset) {
        this.isReset = false;
        return '';
      }
      return 'Minimum 6 characters.';
    }
  }
});

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'forgotPassword',
  data: function data() {
    return {
      isLoading: false,
      isReset: false,
      error: {
        email: this.msgAlias
      },
      email: '',
      msg: ''
    };
  },

  methods: {
    resetFields: function resetFields() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.isReset = true;
    },
    isEmailValid: function isEmailValid() {
      if (this.$helpers.isEmail(this.email)) {
        this.error.email = '';
        return true;
      }
      this.error.email = this.msgEmail;
      return false;
    },
    submitForgotPassword: function submitForgotPassword() {
      var _this = this;

      if (!this.isEmailValid()) {
        return;
      }
      this.isLoading = true;
      this.$http.post('/scarf/forgotPassword', {
        email: this.email
      }).then(function (res) {
        _this.isLoading = false;
        console.log('forgot pass:', res.data);
        // Wrong credentials. Access denied.
        _this.resetFields();
        if (res.data.ok === 1) {
          _this.msg = 'Check you email to reset password.';
        } else {
          _this.msg = res.data.message;
        }
      });
    }
  },
  watch: {
    email: function email(val) {
      if (this.$helpers.isEmail(val)) {
        this.error.email = '';
        return;
      }
      this.error.email = this.msgEmail;
    }
  },
  computed: {
    msgEmail: function msgEmail() {
      if (this.isReset) {
        this.isReset = false;
        return '';
      }
      return 'Enter valid email';
    }
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'getData',
  data: function data() {
    return {
      isLoading: false,
      isReset: false,
      error: {
        email: this.msgAlias
      },
      email: '',
      msg: '',
      orgId: 0,
      isOrgsLoading: true,
      orgs: []
    };
  },

  methods: {
    resetFields: function resetFields() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.isReset = true;
    },
    getData: function getData() {
      var _this = this;

      this.isLoading = true;
      this.$http.get('/scarf/all-results/' + this.orgId, {
        params: {
          token: this.$user.token
        }
      }).then(function (res) {
        _this.isLoading = false;
        // console.log('data:', res.data);
        var blob = new Blob([res.data], { type: 'text/csv' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = String(new Date()).substring(4, 24).replace(/[: ]/g, '-') + '.csv';
        document.body.append(link);
        link.click();
      });
    },
    getOrgs: function getOrgs() {
      var _this2 = this;

      this.isOrgsLoading = true;
      this.$http.get('/scarf/orgs', {
        params: {
          token: this.$user.token
        }
      }).then(function (res) {
        _this2.isOrgsLoading = false;
        _this2.orgs = res.data.data;
      });
    }
  },
  created: function created() {
    this.getOrgs();
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  components: {},
  data: function data() {
    return {
      asOf: '',
      // numbers based on discussion with Sachin
      count2018: 2475,
      count2019: 0,
      count2020: 0,
      countTotal: 0,
      quarters: [{
        name: 'Q1 (Jan-Mar)',
        count: 2213
      }, {
        name: 'Q2 (Apr-Jun)',
        count: 2169
      }, {
        name: 'Q3 (Jul-Sep)',
        count: 1950
      }, {
        name: 'Q4 (Oct-Dec)',
        count: 2252,
        remarks: true
      }],
      quarters2020: [{
        name: 'Q1 (Jan-Feb)',
        count: 2230
      }],
      orgs: ['CCTE College', 'D.G.Vaishnav College', 'Don Bosco School', 'Government Girls Higher Secondary School (Ashok Nagar)', 'Grace Matriculation School', 'Hindu College', 'Jessie Mosses Higher Secondary School', 'SBOA', 'Seetha Kingston School', 'Stella Maris College']
    };
  },
  created: function created() {
    var _this = this;

    this.count2019 = 0;
    this.count2020 = 0;
    this.quarters.forEach(function (q) {
      _this.count2019 += q.count;
    });
    this.quarters2020.forEach(function (q) {
      _this.count2020 += q.count;
    });
    this.countTotal = this.count2018 + this.count2019 + this.count2020;
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_buefy__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_buefy_lib_buefy_min_css__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_buefy_lib_buefy_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_buefy_lib_buefy_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_main_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_css_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_css_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(79);











__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_buefy___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  baseURL: 'https://scarfs.trustcircle.co'
});

console.log = function log() {};

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$temp = {
  get sessionCode() {
    return window.localStorage.scarfSessionId;
  },
  set sessionCode(value) {
    window.localStorage.scarfSessionId = value;
  },
  get testId() {
    return window.localStorage.scarfTestId;
  },
  set testId(value) {
    window.localStorage.scarfTestId = value;
  },
  endSession: function endSession() {
    window.localStorage.removeItem('scarfSessionId');
  },
  checkIsSessionEnded: function checkIsSessionEnded() {
    this.$toast.open('Your session ended. Enter your organization code and try again.');
    this.$router.push('/');
  }
};

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

// const tld = process.env.tld;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$user = {
  get token() {
    return window.localStorage.trustcircle_token;
  },
  set token(value) {
    window.localStorage.trustcircle_token = value;
  },
  get user() {
    var user = void 0;
    if (window.localStorage.user) {
      try {
        user = JSON.parse(window.localStorage.user);
      } catch (e) {
        delete window.localStorage.user;
      }
      return user;
    }
    return user;
  },
  set user(obj) {
    window.localStorage.user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj);
  },
  logout: function logout() {
    window.localStorage.removeItem('trustcircle_token');
    window.localStorage.removeItem('user');
  }
};

var patterns = {
  orgCodePattern: /^[a-zA-Z0-9]{8}$/
};

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$helpers = {
  pageOffset: 0,
  urlMainWebsite: "https://trustcircle.co",
  isOrgCode: function isOrgCode(val) {
    return patterns.orgCodePattern.test(val);
  },

  // login module
  isPassword: function isPassword(pwd) {
    return (/^(.+){6,}/.test(pwd)
    );
  },
  isEmail: function isEmail(email) {
    /* eslint-disable no-useless-escape */
    return (/^[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/.test(email)
    );
  },
  isAlias: function isAlias(alias) {
    return (/^[a-zA-Z][a-zA-Z0-9]{4,}$/.test(alias)
    );
  }
};

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */]);
  }
});

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */,
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(17);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7abf566_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(78);
function injectStyle (ssrContext) {
  __webpack_require__(77)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e7abf566"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7abf566_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav',{staticClass:"navbar is-fixed-top"},[_c('div',{staticClass:"navbar-brand"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navbar-burger",class:{ 'is-active': _vm.isMenuActive },attrs:{"data-target":"navMenu"},on:{"click":_vm.toggleMenu}},[(_vm.isMenuActive)?_c('i',{staticClass:"fa fa-times tc-fa-menu fa-2x"}):_c('i',{staticClass:"fa fa-bars tc-fa-menu fa-2x"})])]),_vm._v(" "),_c('div',{staticClass:"navbar-menu",class:{ 'is-active' : _vm.isMenuActive },attrs:{"id":"navMenu"}},[_c('div',{staticClass:"navbar-start",on:{"click":_vm.toggleMenu}},[_c('a',{staticClass:"navbar-item",attrs:{"href":"/check-result"}},[_vm._v("Check Result")])])])]),_vm._v(" "),_c('div',{staticClass:"fixed-top-spacer"}),_vm._v(" "),_c('router-view',{staticClass:"border"}),_vm._v(" "),_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"has-text-centered column is-4"},[_c('div',{attrs:{"id":"sister"}},[_c('br'),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":_vm.urlTermsAndPrivacy}},[_vm._v("Terms & Privacy Policy")]),_vm._v(" "),_c('br')])])]),_vm._v(" "),_vm._m(3)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-item",attrs:{"href":"/"}},[_c('img',{attrs:{"src":"/static/img/tclogo.png","alt":"TrustCircle","width":"28","height":"28"}}),_vm._v("\n            \n          "),_c('span',[_vm._v("SCARF Project")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-centered column is-4"},[_c('br'),_vm._v("\n          2019 ©\n          "),_c('a',{attrs:{"href":"https://trustcircle.co"}},[_vm._v("TrustCircle")]),_vm._v(",\n          "),_c('a',{attrs:{"href":"http://www.scarfindia.org/"}},[_vm._v("SCARF")]),_vm._v(",\n          &\n          "),_c('a',{attrs:{"href":"https://www.nihr.ac.uk/"}},[_vm._v("NIHR")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-centered column is-4"},[_c('a',{attrs:{"target":"_blank","href":"http://twitter.com/trustcircle"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fab fa-twitter"})])]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://www.linkedin.com/company/10691880"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fab fa-linkedin"})])]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"http://facebook.com/trustcircleco"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fab fa-facebook-f"})])]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:info@trustcircle.co"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-envelope"})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n          Created with\n          "),_c('span',{staticClass:"icon is-danger"},[_c('i',{staticClass:"fa fa-heart"})]),_vm._v("\n          by TrustCircle Team\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"has-text-centered column is-4"},[_vm._v("\n          A Collaborating Centre\n          "),_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"static/img/who-centre-for-mental-health-research-scarf-trustcircle-partner.png","alt":"WHO"}}),_vm._v(" "),_c('br'),_vm._v("\n          for Mental Health Research & Training\n        ")]),_vm._v(" "),_c('div',{staticClass:"has-text-centered column is-4"}),_vm._v(" "),_c('div',{staticClass:"has-text-centered column is-4"},[_c('br'),_vm._v(" "),_c('img',{attrs:{"src":"static/img/funded-by-NIHR.png","alt":"NIHR"}}),_vm._v(" "),_c('br')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Main__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_EnglishConsentForm__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Demographics__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TamilConsentForm__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_HindiConsentForm__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MarathiConsentForm__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_EnglishParticipationInfo__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_TamilParticipationInfo__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_HindiParticipationInfo__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_MarathiParticipationInfo__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Summary__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Tests__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Results__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_CheckResults__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_LanguageSelection__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_login_Login__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_login_ForgotPassword__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Data__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Dashboard__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_ga__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_ga__);























__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Main',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Main__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_17__components_login_Login__["a" /* default */]
  }, {
    path: '/data',
    name: 'Data',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Data__["a" /* default */]
  }, {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: __WEBPACK_IMPORTED_MODULE_18__components_login_ForgotPassword__["a" /* default */]
  }, {
    path: '/demographics/:language',
    name: 'Demographics',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Demographics__["a" /* default */],
    props: true
  }, {
    path: '/consent-form-tamil',
    name: 'TamilConsentForm',
    component: __WEBPACK_IMPORTED_MODULE_5__components_TamilConsentForm__["a" /* default */]
  }, {
    path: '/consent-form-english',
    name: 'EnglishConsentForm',
    component: __WEBPACK_IMPORTED_MODULE_3__components_EnglishConsentForm__["a" /* default */]
  }, {
    path: '/consent-form-hindi',
    name: 'HindiConsentForm',
    component: __WEBPACK_IMPORTED_MODULE_6__components_HindiConsentForm__["a" /* default */]
  }, {
    path: '/consent-form-marathi',
    name: 'MarathiConsentForm',
    component: __WEBPACK_IMPORTED_MODULE_7__components_MarathiConsentForm__["a" /* default */]
  }, {
    path: '/participation-info-tamil',
    name: 'TamilParticipationInfo',
    component: __WEBPACK_IMPORTED_MODULE_9__components_TamilParticipationInfo__["a" /* default */]
  }, {
    path: '/participation-info-english',
    name: 'EnglishParticipationInfo',
    component: __WEBPACK_IMPORTED_MODULE_8__components_EnglishParticipationInfo__["a" /* default */]
  }, {
    path: '/participation-info-hindi',
    name: 'HindiParticipationInfo',
    component: __WEBPACK_IMPORTED_MODULE_10__components_HindiParticipationInfo__["a" /* default */]
  }, {
    path: '/participation-info-marathi',
    name: 'MarathiParticipationInfo',
    component: __WEBPACK_IMPORTED_MODULE_11__components_MarathiParticipationInfo__["a" /* default */]
  }, {
    path: '/tests/:language',
    name: 'Tests',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Tests__["a" /* default */],
    props: true
  }, {
    path: '/summary',
    name: 'Summary',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Summary__["a" /* default */]
  }, {
    path: '/results',
    name: 'Results',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Results__["a" /* default */]
  }, {
    path: '/check-result',
    name: 'CheckResults',
    component: __WEBPACK_IMPORTED_MODULE_15__components_CheckResults__["a" /* default */]
  }, {
    path: '/language-selection',
    name: 'LanguageSelection',
    component: __WEBPACK_IMPORTED_MODULE_16__components_LanguageSelection__["a" /* default */]
  }, {
    path: '/dashboard',
    component: __WEBPACK_IMPORTED_MODULE_20__components_Dashboard__["a" /* default */]
  }],
  mode: 'history'
});

var isLoggedIn = function isLoggedIn() {
  var token = window.localStorage.trustcircle_token;
  return !!token;
};

router.beforeEach(function (to, from, next) {
  // console.log('beforeEach:', to, from);
  if (to.path !== '/data') {
    next();
  } else {
    console.log('routing to resources');
    if (isLoggedIn()) {
      next();
    } else {
      next({
        path: '/login'
      });
    }
  }
});

__WEBPACK_IMPORTED_MODULE_21_vue_ga___default()(router, 'UA-97456193-5');

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 80 */,
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf5c5414_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(89);
function injectStyle (ssrContext) {
  __webpack_require__(82)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cf5c5414"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf5c5414_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Banner_vue__ = __webpack_require__(19);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3531bd7e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banner_vue__ = __webpack_require__(88);
function injectStyle (ssrContext) {
  __webpack_require__(84)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3531bd7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Banner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3531bd7e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageC_vue__ = __webpack_require__(20);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c0862ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageC_vue__ = __webpack_require__(87);
function injectStyle (ssrContext) {
  __webpack_require__(86)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c0862ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageC_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c0862ce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageC_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"placeholder",attrs:{"id":"imageC"}},[(!_vm.isLargeLoaded)?_c('img',{staticClass:"img-small",class:{ loaded: _vm.isSmallLoaded },attrs:{"src":_vm.imageSmall},on:{"load":function($event){_vm.setSmall()}}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"img-large",class:{ loaded: _vm.isLargeLoaded },attrs:{"src":_vm.imageLarge},on:{"load":function($event){_vm.setLarge()}}}),_vm._v(" "),_c('div',{style:(_vm.getPadding())})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"banner"}},[_c('div',{staticClass:"media-container"},[_c('ImageC',{attrs:{"imageSmall":_vm.imageSmall,"imageLarge":_vm.imageLarge,"paddingBottom":_vm.paddingBottom}}),_vm._v(" "),_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"slogan has-text-centered"},[_c('h1',{staticClass:"slogan-title"},[_vm._v("\n          "+_vm._s(_vm.title)+"\n        ")]),_vm._v(" "),_c('h2',{staticClass:"slogan-subtitle",domProps:{"innerHTML":_vm._s(_vm.desc)}})])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mainView"}},[_c('Banner',{attrs:{"imageSmall":"https://trustcircle-images.s3.ap-south-1.amazonaws.com/landings/trustcircle-scarf-school-screening-small.jpg","imageLarge":"https://trustcircle-images.s3.ap-south-1.amazonaws.com/landings/trustcircle-scarf-school-screening.jpg","paddingBottom":"50.5%","title":"Wellbeing Assessments for Schools/Colleges","desc":"Stay happy and emotionally resilient with early health checkup in schools and colleges"}}),_vm._v(" "),_c('section',{staticClass:"hero is-small"},[_c('div',{staticClass:"hero-body"},[_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"has-text-centered"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.orgCode),expression:"orgCode"}],staticClass:"input is-large",attrs:{"type":"text","placeholder":"Organization Code"},domProps:{"value":(_vm.orgCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.orgCode=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"is-danger help"},[_vm._v(_vm._s(_vm.error.orgCode))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button is-large",class:{"is-loading": _vm.isLoading},on:{"click":function($event){_vm.next()}}},[_vm._v("Enter")])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container features"},[_c('h2',{staticClass:"is-size-5"},[_vm._v("\n          The session has the following steps:\n          "),_c('br'),_vm._v(" "),_c('ol',{staticClass:"is-offset-1 is-size-6"},[_c('li',[_vm._v("Enter Access Code")]),_vm._v(" "),_c('li',[_vm._v("Read the general information")]),_vm._v(" "),_c('li',[_vm._v("Attend the well-being assessments")]),_vm._v(" "),_c('li',[_vm._v("Check your results")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnglishConsentForm_vue__ = __webpack_require__(21);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d675a7c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnglishConsentForm_vue__ = __webpack_require__(92);
function injectStyle (ssrContext) {
  __webpack_require__(91)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8d675a7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnglishConsentForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d675a7c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnglishConsentForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section content",attrs:{"id":"englishConsentForm"}},[_c('h1',{staticClass:"title has-text-centered"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agreed),expression:"agreed"}],staticClass:"is-large",attrs:{"type":"checkbox","id":"checkbox","disabled":_vm.disagreed},domProps:{"checked":Array.isArray(_vm.agreed)?_vm._i(_vm.agreed,null)>-1:(_vm.agreed)},on:{"change":function($event){var $$a=_vm.agreed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.agreed=$$a.concat([$$v]))}else{$$i>-1&&(_vm.agreed=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.agreed=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"is-size-5",attrs:{"for":"checkbox"}},[_vm._v("  I agree to above points.")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.disagreed),expression:"disagreed"}],staticClass:"is-large",attrs:{"type":"checkbox","id":"checkbox","disabled":_vm.agreed},domProps:{"checked":Array.isArray(_vm.disagreed)?_vm._i(_vm.disagreed,null)>-1:(_vm.disagreed)},on:{"change":function($event){var $$a=_vm.disagreed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.disagreed=$$a.concat([$$v]))}else{$$i>-1&&(_vm.disagreed=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.disagreed=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"is-size-5",attrs:{"for":"checkbox"}},[_vm._v("  I disagree to above points.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.agreed)?_c('div',{staticClass:"has-text-centered"},[_c('button',{staticClass:"button is-large is-info",on:{"click":function($event){_vm.next()}}},[_vm._v("Next >>")])]):_vm._e(),_vm._v(" "),(_vm.disagreed)?_c('div',{staticClass:"has-text-centered"},[_c('div',{staticClass:"control control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reasonForDecline),expression:"reasonForDecline"}],staticClass:"input",attrs:{"type":"text","placeholder":"Please type in reason for disagreeing","disabled":_vm.isFeedbackSend},domProps:{"value":(_vm.reasonForDecline)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reasonForDecline=$event.target.value}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button is-large is-danger",attrs:{"disabled":_vm.isFeedbackSend},on:{"click":function($event){_vm.decline()}}},[_vm._v("<< Decline")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"has-text-centered"},[_c('b',[_vm._v("NIHR Global Health Research Group on Psychosis outcome: Warwick-India-Canada (WIC) Network")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticClass:"has-text-centered"},[_c('b',[_vm._v("SCARF commissioned study - School and college based interventions for early detection and referral of adolescent and young individuals with psychosis")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_c('p',[_vm._v("\n          I confirm that I have read and understand the "),_c('a',{attrs:{"href":"/participation-info-english"}},[_vm._v("Participant Information Sheet ")]),_vm._v(" for the above project.  I have had the opportunity to consider the information and have had these answered satisfactorily.\n        ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n          I understand that my participation is voluntary and that I am free to withdraw at any time without giving any reason.\n        ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n          I consent that the data collected through the app can be used for research purpose.\n        ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n          I understand that the data collected during this study will have confidentiality and anonymity will be maintained and it will not be possible to identify you from the publication.\n        ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n          I understand that all information I share will be kept in a secure and confidential manner and will not be shared with anyone other than those involved in the research.\n        ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n          I agree to take part in the above project.\n        ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demographics_vue__ = __webpack_require__(22);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc535580_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Demographics_vue__ = __webpack_require__(97);
function injectStyle (ssrContext) {
  __webpack_require__(94)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cc535580"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demographics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc535580_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Demographics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sessionInfo"}},[_c('div',{staticClass:"notification is-info"},[(_vm.testId === 2)?_c('div',[_c('p',[_vm._v("Your Id: "+_vm._s(_vm.userId))]),_vm._v(" "),_c('p',[_vm._v("Note this down so that you can check your results later.")])]):_vm._e(),_vm._v(" "),(_vm.testId === 3)?_c('div',[_c('p',[_vm._v("உங்கள் ஐடி: "+_vm._s(_vm.userId))]),_vm._v(" "),_c('p',[_vm._v("இந்த ஐடியை நினைவில் கொள்ளுங்கள், பிறகு உங்கள் முடிவுகளை நீங்கள் பார்க்கலாம்.")])]):_vm._e(),_vm._v(" "),(_vm.testId === 6)?_c('div',[_c('p',[_vm._v("Your Id: "+_vm._s(_vm.userId))]),_vm._v(" "),_c('p',[_vm._v("Note this down so that you can check your results later.")])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",attrs:{"id":"Demographics"}},[_c('div',{staticClass:"box"},[_c('h1',{staticClass:"title"},[_vm._v("Socio-demographic performa")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.isLoading)?_c('div',[_vm._v("\n      Loading...\n      "),_c('i',{staticClass:"fa fa-spinner fa-2x"})]):_c('div',[_vm._l((_vm.demographicQues),function(demographicQues,qIndex){return _c('div',[_c('div',{staticClass:"is-size-6"},[_c('b',[(_vm.isMandatoryField(qIndex))?_c('span',[_vm._v("*")]):_vm._e(),_vm._v(_vm._s(demographicQues.question))])]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},_vm._l((demographicQues.options),function(option,index){return _c('div',{staticClass:"column is-3 is-outlined"},[(option !== 'Text')?_c('div',[_c('a',{staticClass:"button",attrs:{"id":(qIndex + "Res" + index)},on:{"click":function($event){_vm.updateOption(index, qIndex)}}},[_vm._v(_vm._s(option))])]):_c('div',[_c('div',{staticClass:"control"},[_c('input',{staticClass:"input",attrs:{"type":"text"},on:{"keyup":function($event){_vm.updateText(index, qIndex, $event.target.value)}}})]),_vm._v(" "),(_vm.questionIndex === qIndex)?_c('div',{staticClass:"is-danger help"},[_vm._v(_vm._s(_vm.errors[qIndex]))]):_vm._e()])])})),_vm._v(" "),_c('br')])}),_vm._v(" "),_c('SessionInfo'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button is-large is-info",class:{ 'is-loading': _vm.isLoadingSubmit },attrs:{"disabled":_vm.isResponseSubmitted},on:{"click":function($event){_vm.sendRequest()}}},[_vm._v("Submit")]),_vm._v("\n          "),(_vm.isResponseSubmitted)?_c('button',{staticClass:"button is-large is-info",on:{"click":function($event){_vm.next()}}},[_vm._v("Next >>")]):_vm._e()],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("Fields with "),_c('b',[_vm._v("'*'")]),_vm._v(" indicate mandatory fields")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TamilConsentForm_vue__ = __webpack_require__(25);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_116e95ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TamilConsentForm_vue__ = __webpack_require__(100);
function injectStyle (ssrContext) {
  __webpack_require__(99)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-116e95ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TamilConsentForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_116e95ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TamilConsentForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section content",attrs:{"id":"tamilConsentForm"}},[_c('h1',{staticClass:"title has-text-centered"},[_vm._v(" ஒப்புதல் படிவம் ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agreed),expression:"agreed"}],staticClass:"is-large",attrs:{"type":"checkbox","id":"checkbox","disabled":_vm.disagreed === true},domProps:{"checked":Array.isArray(_vm.agreed)?_vm._i(_vm.agreed,null)>-1:(_vm.agreed)},on:{"change":function($event){var $$a=_vm.agreed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.agreed=$$a.concat([$$v]))}else{$$i>-1&&(_vm.agreed=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.agreed=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"is-size-5",attrs:{"for":"checkbox"}},[_vm._v("  நான் ஒப்புக்கொள்கிறேன்")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.disagreed),expression:"disagreed"}],staticClass:"is-large",attrs:{"type":"checkbox","id":"checkbox","disabled":_vm.agreed === true},domProps:{"checked":Array.isArray(_vm.disagreed)?_vm._i(_vm.disagreed,null)>-1:(_vm.disagreed)},on:{"change":function($event){var $$a=_vm.disagreed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.disagreed=$$a.concat([$$v]))}else{$$i>-1&&(_vm.disagreed=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.disagreed=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"is-size-5",attrs:{"for":"checkbox"}},[_vm._v("  நான்  ஒப்புகொள்ளமறுக்கிறேன்")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.agreed)?_c('div',{staticClass:"has-text-centered"},[_c('button',{staticClass:"button is-large is-info",on:{"click":function($event){_vm.next()}}},[_vm._v("Next >>")])]):_vm._e(),_vm._v(" "),(_vm.disagreed)?_c('div',{staticClass:"has-text-centered"},[_c('div',{staticClass:"control control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reasonForDecline),expression:"reasonForDecline"}],staticClass:"input",attrs:{"type":"text","placeholder":"Please type in reason for disagreeing","disabled":_vm.isFeedbackSend},domProps:{"value":(_vm.reasonForDecline)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reasonForDecline=$event.target.value}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button is-large is-danger",attrs:{"disabled":_vm.isFeedbackSend},on:{"click":function($event){_vm.decline()}}},[_vm._v("<< Decline")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"has-text-centered"},[_c('b',[_vm._v("NIHR மனநோய் உலக சுகாதார ஆராய்ச்சி குழு : வார்விக் -இந்தியா -கனடா  (WIC) நெட்ஒர்க் ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_c('p',[_vm._v("\n              நான் இந்த "),_c('a',{attrs:{"href":"/participation-info-tamil"}},[_vm._v(" ஆராய்ச்சியில் பங்கு பெறுவதற்கான ஒப்புதல் ")]),_vm._v(" படிவத்தை நன்றாக புரிந்து கொண்டேன். நான் கேட்ட கேள்விகளுக்கு அவர்கள் அளித்த பதில்கள் எனக்கு திருப்திகரமாக இருந்தது.\n        ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n              நான் என்னுடைய சுய விருப்பத்தில்; பங்கு பெறுகிறேன் மற்றும் எந்த நேரத்திலும் எந்த விதமான முன் அறிவிப்பின்றி  இந்த ஆராய்ச்சியிலிருந்து விலகி கொள்ளலாம் என்று புரிந்து  கொண்டேன்.\n\t    ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n              நான் ஆராய்ச்சியில் பங்கு பெறுவதற்கும் கேள்வி மற்றும் பேட்டியில் கலந்து கொள்வதற்கும் ஒப்புதல் அளிக்கின்றேன்.\n        ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n              என்னை பற்றி சேகரிக்கபட்ட தகவல்களை இறுதி அறிக்கை மூலம் வெளியிட நான் சம்மதிக்கிறேன் (இது ரகசியமாக உங்கள் பற்றின விவரங்கள் தெரியாமல் பாதுகாக்கப்படும்).\n        ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n              எதிர்காலத்தில் உங்களை தொடர்பு கொள்ள இந்த மதீப்பீடு உதவியாக இருக்கும் என்று புரிந்து கொண்டேன்.\n        ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n              ஆராய்ச்சியின் நோக்கங்களுக்காக என்னுடைய மருத்துவ தகவல்களை ஆராய்ச்சியாளர்கள் அணுகுவதற்கு நான் சம்மதம் அளிக்கிறேன். என்னுடைய தகவல்கள் அனைத்தையும் ஆராய்ச்சியாளர்கள் மிகவும் நம்பகத்தன்மையும் பகுப்பாய்வு செய்வார்கள் என்று புரிந்து கொண்டேன்.\n        ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n              இந்த ஆராய்ச்சியில் பங்கு பெற ஒப்புதல் அளிக்கிறேன்.\n\t    ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("\n              என்னால் கொடுக்கப்பட்ட விவரங்கள் அனைத்தும் பரிந்துரைக்கப்பட்ட நபரால் இந்த ஆராய்ச்சி முடியும் வரை உதவி புரிய சம்மதிக்கிறேள்.\n\t    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HindiConsentForm_vue__ = __webpack_require__(26);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c025f76_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HindiConsentForm_vue__ = __webpack_require__(103);
function injectStyle (ssrContext) {
  __webpack_require__(102)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c025f76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HindiConsentForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c025f76_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HindiConsentForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section content",attrs:{"id":"englishConsentForm"}},[_c('h1',{staticClass:"title has-text-centered"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agreed),expression:"agreed"}],staticClass:"is-large",attrs:{"type":"checkbox","id":"checkbox","disabled":_vm.disagreed},domProps:{"checked":Array.isArray(_vm.agreed)?_vm._i(_vm.agreed,null)>-1:(_vm.agreed)},on:{"change":function($event){var $$a=_vm.agreed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.agreed=$$a.concat([$$v]))}else{$$i>-1&&(_vm.agreed=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.agreed=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"is-size-5",attrs:{"for":"checkbox"}},[_vm._v("  I agree to above points.")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.disagreed),expression:"disagreed"}],staticClass:"is-large",attrs:{"type":"checkbox","id":"checkbox","disabled":_vm.agreed},domProps:{"checked":Array.isArray(_vm.disagreed)?_vm._i(_vm.disagreed,null)>-1:(_vm.disagreed)},on:{"change":function($event){var $$a=_vm.disagreed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.disagreed=$$a.concat([$$v]))}else{$$i>-1&&(_vm.disagreed=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.disagreed=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"is-size-5",attrs:{"for":"checkbox"}},[_vm._v("  I disagree to above points.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.agreed)?_c('div',{staticClass:"has-text-centered"},[_c('button',{staticClass:"button is-large is-info",on:{"click":function($event){_vm.next()}}},[_vm._v("Next >>")])]):_vm._e(),_vm._v(" "),(_vm.disagreed)?_c('div',{staticClass:"has-text-centered"},[_c('div',{staticClass:"control control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reasonForDecline),expression:"reasonForDecline"}],staticClass:"input",attrs:{"type":"text","placeholder":"Please type in reason for disagreeing","disabled":_vm.isFeedbackSend},domProps:{"value":(_vm.reasonForDecline)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reasonForDecline=$event.target.value}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button is-large is-danger",attrs:{"disabled":_vm.isFeedbackSend},on:{"click":function($event){_vm.decline()}}},[_vm._v("<< Decline")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"has-text-centered"},[_c('b',[_vm._v("NIHR Global Health Research Group on Psychosis outcome: Warwick-India-Canada (WIC) Network")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticClass:"has-text-centered"},[_c('b',[_vm._v("SCARF commissioned study - School and college based interventions for early detection and referral of adolescent and young individuals with psychosis")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_c('p',[_vm._v("\n        I confirm that I have read and understand the\n        "),_c('a',{attrs:{"href":"/participation-info-hindi"}},[_vm._v("Participant Information Sheet ")]),_vm._v("\n        for the above project. I have had the opportunity to consider the information and have had these answered satisfactorily.\n      ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("I understand that my participation is voluntary and that I am free to withdraw at any time without giving any reason.")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("I consent that the data collected through the app can be used for research purpose.")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("I understand that the data collected during this study will have confidentiality and anonymity will be maintained and it will not be possible to identify you from the publication.")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("I understand that all information I share will be kept in a secure and confidential manner and will not be shared with anyone other than those involved in the research.")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("I agree to take part in the above project.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarathiConsentForm_vue__ = __webpack_require__(27);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_200727f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarathiConsentForm_vue__ = __webpack_require__(106);
function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-200727f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarathiConsentForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_200727f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarathiConsentForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section content",attrs:{"id":"englishConsentForm"}},[_c('h1',{staticClass:"title has-text-centered"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agreed),expression:"agreed"}],staticClass:"is-large",attrs:{"type":"checkbox","id":"checkbox","disabled":_vm.disagreed},domProps:{"checked":Array.isArray(_vm.agreed)?_vm._i(_vm.agreed,null)>-1:(_vm.agreed)},on:{"change":function($event){var $$a=_vm.agreed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.agreed=$$a.concat([$$v]))}else{$$i>-1&&(_vm.agreed=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.agreed=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"is-size-5",attrs:{"for":"checkbox"}},[_vm._v("  I agree to above points.")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.disagreed),expression:"disagreed"}],staticClass:"is-large",attrs:{"type":"checkbox","id":"checkbox","disabled":_vm.agreed},domProps:{"checked":Array.isArray(_vm.disagreed)?_vm._i(_vm.disagreed,null)>-1:(_vm.disagreed)},on:{"change":function($event){var $$a=_vm.disagreed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.disagreed=$$a.concat([$$v]))}else{$$i>-1&&(_vm.disagreed=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.disagreed=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"is-size-5",attrs:{"for":"checkbox"}},[_vm._v("  I disagree to above points.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.agreed)?_c('div',{staticClass:"has-text-centered"},[_c('button',{staticClass:"button is-large is-info",on:{"click":function($event){_vm.next()}}},[_vm._v("Next >>")])]):_vm._e(),_vm._v(" "),(_vm.disagreed)?_c('div',{staticClass:"has-text-centered"},[_c('div',{staticClass:"control control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reasonForDecline),expression:"reasonForDecline"}],staticClass:"input",attrs:{"type":"text","placeholder":"Please type in reason for disagreeing","disabled":_vm.isFeedbackSend},domProps:{"value":(_vm.reasonForDecline)},on:{"input":function($event){if($event.target.composing){ return; }_vm.reasonForDecline=$event.target.value}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button is-large is-danger",attrs:{"disabled":_vm.isFeedbackSend},on:{"click":function($event){_vm.decline()}}},[_vm._v("<< Decline")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"has-text-centered"},[_c('b',[_vm._v("NIHR Global Health Research Group on Psychosis outcome: Warwick-India-Canada (WIC) Network")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticClass:"has-text-centered"},[_c('b',[_vm._v("SCARF commissioned study - School and college based interventions for early detection and referral of adolescent and young individuals with psychosis")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_c('p',[_vm._v("\n        I confirm that I have read and understand the\n        "),_c('a',{attrs:{"href":"/participation-info-marathi"}},[_vm._v("Participant Information Sheet ")]),_vm._v("\n        for the above project. I have had the opportunity to consider the information and have had these answered satisfactorily.\n      ")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("I understand that my participation is voluntary and that I am free to withdraw at any time without giving any reason.")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("I consent that the data collected through the app can be used for research purpose.")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("I understand that the data collected during this study will have confidentiality and anonymity will be maintained and it will not be possible to identify you from the publication.")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("I understand that all information I share will be kept in a secure and confidential manner and will not be shared with anyone other than those involved in the research.")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("I agree to take part in the above project.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnglishParticipationInfo_vue__ = __webpack_require__(28);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c212d0a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnglishParticipationInfo_vue__ = __webpack_require__(109);
function injectStyle (ssrContext) {
  __webpack_require__(108)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c212d0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EnglishParticipationInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c212d0a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EnglishParticipationInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",attrs:{"id":"englishParticipationInfo"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box"},[_c('h1',{staticClass:"title has-text-centered"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._m(1),_c('br'),_vm._v(" "),_vm._m(2),_c('br'),_vm._v(" "),_c('p',[_vm._v("\n        You are being invited to take part in this research study being conducted by the Schizophrenia Research Foundation (SCARF) and is led by Dr. R Thara. This is part of a programme on early identification and management of first-episode psychosis among school and college students.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Before you decide to take part, it is important for you to understand why the research is being done and what it will involve. Please take time to read the following information sheet carefully. Ask us if there is anything that is not clear or if you would like more information. Take time to decide whether you wish to take part.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Thank you for reading this. \n      ")]),_c('br'),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',[_vm._v("\n        This study is designed to create a model of community awareness and early detection for youth mental health. Under this programme, a school based programme using community resources such as   teachers, peers and youth groups will be piloted.\n      ")]),_c('br'),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('p',[_vm._v("\n        You have been invited to take part because you are a student at a school or college in the project area. Your participation in this study will help us better understand the mental health issues faced by young people. This will enable us to develop strategies and address the emerging issues on mental health.\n      ")]),_c('br'),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('p',[_vm._v("\n        It is up to you to decide whether to take part. If you do decide to take part you will be given this information sheet to keep and will be asked to sign a consent form. If you decide to take part you are still free to withdraw at any time, without giving a reason.\n      ")]),_c('br'),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('p',[_vm._v("\n        If you choose to participate you will likely benefit by understanding your own mental health better. There is an indirect benefit that the findings from this study will ultimately contribute to our better understanding of mental health and disorders in the youth and it will lead to the improvement of mental health for young people.\n      ")]),_c('br'),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('p',[_vm._v("\n        You will be asked to answer a series of questions which are part of a screening test for mental health app. This will approximately take 15 minutes of your time. The information collected on this screening tool will assess your mental health status.\n      ")]),_c('br'),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('p',[_vm._v("\n        Other than taking up some of your time, there are no disadvantages and risks involved in taking part in this study\n      ")]),_c('br'),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('p',[_vm._v("\n        Yes. If you consent to take part in the research anything you say will be anonymised and both recordings and transcripts will be held securely.\n      ")]),_c('br'),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('p',[_vm._v("\n        The results of the study will be published in scientific or medical journals and presented at conferences.  Copies of the published results will be available to you on request after the data collection is finished and the analyses have been performed. Your name will not be linked to the publications in any way.\n      ")]),_c('br'),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('p',[_vm._v("\n        This study is being carried out by researchers at SCARF in collaboration with University of Warwick. The study is funded by the National Institute of Health Research, UK.\n      ")]),_c('br'),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('p',[_vm._v("\n        An ethics committee has reviewed the study for compliance with medical and ethical standards and for scientific value.\n      ")]),_c('br'),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('p',[_vm._v("\n        Whenever you want to get more information on this study, please contact:\n      ")]),_c('br'),_vm._v(" "),_c('p',[_vm._v("Dr. R. Thara")]),_vm._v(" "),_c('p',[_vm._v("Address: SCARF, Mental Health centre, R/7A, North Main Road, Anna Nagar, West Extension,")]),_vm._v(" "),_c('p',[_vm._v("Ch-101")]),_vm._v(" "),_c('p',[_vm._v("Tel:044 26153971, E-mail: thara@scarfindia.org ")]),_c('br'),_vm._v(" "),_c('p',[_vm._v("If you have complaints regarding the conduct of the study please contact:")]),_c('br'),_vm._v(" "),_c('p',[_vm._v("Dr. Lakshmi Vijaykumar")]),_c('br'),_vm._v(" "),_c('p',[_vm._v("Chairperson, IEC of SCARF, ")]),_vm._v(" "),_c('p',[_vm._v("SCARF, Mental Health Centre, R/7A, North Main Road, Anna Nagar, West Extension, Chennai")]),_vm._v(" "),_c('p',[_vm._v("-600101")]),_vm._v(" "),_c('p',[_vm._v("Tel: 24981939")]),_c('br'),_vm._v(" "),_vm._m(14),_c('br')])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/consent-form-english"}},[_c('i',{staticClass:"fa fa-arrow-left"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"has-text-centered"},[_c('b',[_vm._v("NIHR Global Health Research Group on Psychosis outcome: Warwick-India-Canada (WIC) Network")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"has-text-centered"},[_c('b',[_vm._v("SCARF commissioned study - School and college based interventions for early detection and referral of adolescent and young individuals with psychosis")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHAT IS THE PURPOSE OF THE STUDY?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHY HAVE I BEEN INVITED TO TAKE PART?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("DO I HAVE TO TAKE PART?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHAT WILL HAPPEN TO ME IF I TAKE PART?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHAT IS THE STUDY PROCEDURE?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHAT ARE THE POSSIBLE DISADVANTAGES AND RISKS OF TAKING PART?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WILL MY TAKING PART IN THIS STUDY BE KEPT CONFIDENTIAL?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHAT WILL HAPPEN TO THE RESULTS OF THE RESEARCH STUDY?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHO IS ORGANISING AND FUNDING THE RESEARCH?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHO HAS REVIEWED THE STUDY?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("CONTACT FOR FURTHER INFORMATION")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("Thank you for considering taking part in this study.  You will be given a copy of the information sheet and a signed consent form to keep.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TamilParticipationInfo_vue__ = __webpack_require__(29);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a9ab821_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TamilParticipationInfo_vue__ = __webpack_require__(112);
function injectStyle (ssrContext) {
  __webpack_require__(111)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a9ab821"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TamilParticipationInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a9ab821_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TamilParticipationInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",attrs:{"id":"tamilParticipationInfo"}},[_c('a',{attrs:{"href":"/consent-form-tamil"}},[_c('i',{staticClass:"fa fa-arrow-left"})]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('h1',{staticClass:"title has-text-centered"},[_vm._v(" ஆய்வில் பங்கேற்பவர்களுக்கான தகவல் ")]),_vm._v(" "),_c('h4',{staticClass:"has-text-centered"},[_c('b',[_vm._v("ஆய்வில் பங்கேற்பவர்களுக்கான தகவல் ")])]),_c('br'),_vm._v(" "),_c('h4',{staticClass:"has-text-centered"},[_c('b',[_vm._v(" ஸ்கார்ப் நடத்தும் ஆய்வு ")]),_vm._v(" – பள்ளி மற்றும் கல்லூரி சார்ந்த செயல்முறைகள் மூலம் இளைஞர்களுக்கிடையே மனச்சிதைவு நோயினை ஆரம்ப கட்டதிலேயே கண்டறிந்து அவர்களுக்கான பரிந்துறைகளை மேற்கொள்ளுதல் பற்றிய ஆய்வு ")]),_c('br'),_vm._v(" "),_c('p',[_vm._v("\n          மனச்சிதைவு ஆராய்ச்சி மையம் நடத்தும் இந்த ஆய்வில் பங்கேற்க நீங்கள் அழைக்கப்பட்டுள்ளீர்கள். இந்த ஆய்வை வழி நடத்துவர் டாக்டர் ஆர்.தாரா. பள்ளி மற்றும் கல்லூரி மாணவர்களிடையே முதல் தடவை தோன்றக்கூடிய மனநோய்க்கான அறிகுறிகளை ஆரம்பகட்டத்திலேயே கண்டறிந்து அதனை பராமரிப்பது பற்றிய ஒரு நிகழ்வின் அங்கமே இந்த ஆய்வாகும்.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n          இந்த ஆராய்ச்சியில் பங்கு பெறும் முன் இந்த ஆய்வு எதற்காக நடக்கிறது என்பதை அறிந்து கொள்வது மிக அவசியம். நேரம் எடுத்துக் கொண்டு இந்த தகவல் படிவத்தை கவனமாகப் படிக்கவும். உங்களுக்கு இதில் ஏதாவது புரியவில்லை என்றாலோ, மேலும் விவரங்கள் தேவைப்பட்டாலோ தயங்காமல் கேட்டுத் தெரிந்துக் கொள்ளுங்கள். நன்கு யோசித்து, இந்த ஆய்வில் பங்குப் பெறுவதா, இல்லையா என்பதை முடிவெடுக்கவும்\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n          இந்த தகவல் படிவத்தை படித்தமைக்கு நன்றி \n      ")]),_c('br'),_vm._v(" "),_c('p',[_c('b',[_vm._v("இந்த ஆய்வின் நோக்கம் என்ன? ")])]),_vm._v(" "),_c('p',[_vm._v("\n          இந்த ஆய்வு சமுதாயத்தில் இளைஞர்கள் மனநலம் குறித்து விழிப்புணர்வு மற்றும் மனநோய்க்கான அறிகுறிகளை ஆரம்பகட்டத்திலேயே கண்டறிவதற்கான ஒரு திட்டமைப்பை உருவாக்குவதே இந்த ஆய்வின் நோக்கமாகும். இந்த ஆய்வில் பள்ளி மற்றும் கல்லூரி சார்ந்த மன நலம் சார்ந்த நிகழ்வுகள் உருவாக்கப்படும். இவை ஆசிரியர்கள் மற்றும் மாணவர்களிடையே செயல்படுத்தப்படும்.\n      ")]),_c('br'),_vm._v(" "),_c('p',[_c('b',[_vm._v("நீங்கள் எதற்காக இதில் பங்கேற்க அழைக்கப்பட்டிருக்கிறீர்கள்? ")])]),_vm._v(" "),_c('p',[_vm._v("\n          நீங்கள் இந்த ஆய்வில் பங்கு பெறுவதற்கான காரணம் என்னவென்றால், இந்த ஆய்வு நடத்தப்படும் பள்ளியில் அல்லது கல்லுரியில் மாணவர்களாக உள்ளீர்கள். \n      ")]),_c('br'),_vm._v(" "),_c('p',[_c('b',[_vm._v("இதில் நீங்கள் பங்கேற்க்க வேண்டுமா? ")])]),_vm._v(" "),_c('p',[_vm._v("\n          இதில் பங்கு பெறலாமா அல்லது வேண்டாமா என்பதை பற்றி முடிவு செய்வது உங்களிடமே உள்ளது. நீங்கள் பங்குபெற முடிவு செய்தால் ஒப்புதல் படிவத்தில் கையொப்பம் இட்டு கலந்து கொண்ட பிறகு விருப்பம் இல்லையென்றால் எந்த நேரத்திலும் இதிலிருந்து விலகிக் கொள்ளலாம்.\n      ")]),_c('br'),_vm._v(" "),_c('p',[_c('b',[_vm._v("இதில் நான் பங்கேற்ப்பதால் எனக்கு என்ன பயன்? ")])]),_vm._v(" "),_c('p',[_vm._v("\n          இந்த ஆய்வில் நீங்கள் பங்கேற்பதால் உங்களின் மனநலம் பற்றிய புரிதல் மேம்படும். அதுமட்டுமன்றி இந்த ஆய்வின் மூலம் அறியப்படும் தகவல்கள் இளைஞர்கள் மனநலம் மற்றும் மனநோய்கள் பற்றி நாங்கள் தெளிவு பெற உதவும். அதனை அறிந்து இளைஞர்கள் மனநலத்தை முன்னேற்றம் அடைய வழிவகுக்கும்.\n      ")]),_c('br'),_vm._v(" "),_c('p',[_c('b',[_vm._v("இந்த ஆய்வின் செயல்முறை என்ன? ")])]),_vm._v(" "),_c('p',[_vm._v("\n          மனநலம் சார்ந்த ஒரு செயலி மூலம் உங்கள் மனநலம் பற்றி கேட்கப்படும் கேள்விகளுக்கு நீங்கள் பதிலளிக்க வேண்டும். இவை சுமாராக 15 நிமிடம் எடுக்கும்.\n      ")]),_c('br'),_vm._v(" "),_c('p',[_c('b',[_vm._v("இதில் பங்கேற்பதால் ஏற்படும் நன்மை, தீமை என்ன? ")])]),_vm._v(" "),_c('p',[_vm._v("\n          இதில் நீங்கள் பங்கேற்பதால் உங்கள் நேரம் செலவாகும். அதைத்தவிர வேறெந்த தீமைகள் மற்றும் ஆபத்து இல்லை.\n      ")]),_c('br'),_vm._v(" "),_c('p',[_c('b',[_vm._v("இதில் நான் பங்கேற்பது ரகசியமாக இருக்குமா? ")])]),_vm._v(" "),_c('p',[_vm._v("\n          நீங்கள் இந்த ஆராய்ச்சியில் பங்கு கொண்டால் நீங்கள் கொடுக்கும் தகவல்கள் அல்லது உங்களை பற்றிய விஷயங்கள் ரகசியமாக வைத்து பாதுகாக்கப்படும். கேள்வித்தாள் மற்றும் நேர்காணல் அனைத்திலும் உங்கள் பெயர் இடம் பெறாது உங்களை நாங்கள் மட்டுமே கண்டுகொள்ள முடியும் அனைத்து தகவல்களும் மிக துல்லியமாக கணிணியில் மிகவும் பாதுகாப்பாக வைக்கப்படும்.\t\n      ")]),_c('br'),_vm._v(" "),_c('p',[_c('b',[_vm._v("இந்த ஆராய்ச்சியின் முடிவுகள் என்ன நடக்கும்? ")])]),_vm._v(" "),_c('p',[_vm._v("\n          இந்த ஆய்வின் முடிவுகள் அறிவியல், மருத்துவ நாளிதழ்கள் மற்றும் மாநாடுகளில் சமர்பிக்கப்படும். இந்த ஆய்விற்குத் தேவையான தகவல் சேகரிப்பு முடிந்து பகுப்பாய்வு செய்யப்பட்ட பிறகு வெளியிடப்பட்ட பிரதிகள் உங்கள் கோரிக்கைகளுக்கு இணங்க உங்களுக்கு கிடைக்கும். எக்காரணத்திலும் இதில் உங்கள் பெயர் இடம் பெறாது என்று உறுதியளிக்கின்றோம்.\n      ")]),_c('br'),_vm._v(" "),_c('p',[_c('b',[_vm._v("இந்த ஆராய்ச்சியை ஒருங்கிணைத்து மற்றும் நிதியுதவி அளிப்பது யார்? ")])]),_vm._v(" "),_c('p',[_vm._v("\n          இந்த ஆய்வு ஸ்கார்பில் உள்ள ஆராய்ச்சியாளர்களால் வார்விக் பல்கலைகழகத்துடன் இனைந்து நடத்தபடுகிறது. இந்த ஆய்விற்கான நிதிஉதவி நேஷனல் இன்ஸிடிடுயுட் ஆப் ஹெல்த் ரிசர்ச், இங்கிலாந்திலிருந்து பெறப்படுகிறது.\n      ")]),_c('br'),_vm._v(" "),_c('p',[_c('b',[_vm._v("இந்த ஆராய்ச்சியினை பரிசீலனை செய்தது யார்? ")])]),_vm._v(" "),_c('p',[_vm._v("\n          நன்னெறிக்குழு இந்த ஆய்வினை மருத்துவ மற்றும் நன்னெறி நெறிமுறைகள் மற்றும் அறிவியல் மதிப்பீடு இருக்கின்றதா என பரிசீலனை செய்கிறது,\n      ")]),_c('br'),_vm._v(" "),_c('p',[_c('b',[_vm._v("மேலும் விவரங்களுக்கு தொடர்பு கொள்ள ")])]),_vm._v(" "),_c('p',[_vm._v("இந்த ஆய்வை பற்றி மேலும் தகவல் பெற விரும்பினால் தயவு செய்து தொடர்பு கொள்ளவும். ")]),_c('br'),_vm._v(" "),_c('p',[_vm._v("மருத்துவர். ஆர்.தாரா ")]),_vm._v(" "),_c('p',[_vm._v("இயக்குநர் ")]),_vm._v(" "),_c('p',[_vm._v("ஸ்காhப் (மனச்சிதைவு நோய் ஆராய்ச்சி மையம்) ")]),_vm._v(" "),_c('p',[_vm._v("ஆர்ஃ7ஏ வடக்கு பிரதான சாலை, ")]),_vm._v(" "),_c('p',[_vm._v("அண்ணாநகர், மேற்கு விரிவாக்கம் ")]),_vm._v(" "),_c('p',[_vm._v("சென்னை – 600 101")]),_vm._v(" "),_c('p',[_vm._v("தொலைபேசி – 044-26153917")]),_c('br'),_vm._v(" "),_c('p',[_vm._v("ஆய்வு தொடர்பான புகார்கள் இருப்பின் தொடர்பு கொள்ள வேண்டிய முகவரி: ")]),_c('br'),_vm._v(" "),_c('p',[_vm._v("மருத்துவர் இலட்சுமி விஐயக்குமார் ")]),_vm._v(" "),_c('p',[_vm._v("செயற்குழு தலைவர் ")]),_vm._v(" "),_c('p',[_vm._v("ஸ்கார்ப் - இந்தியா ")]),_vm._v(" "),_c('p',[_vm._v("தொலைபேசி – 044-24981939")]),_c('br'),_vm._v(" "),_c('p',[_c('b',[_vm._v("உங்கள் வருகைக்கு நன்றி. உங்களிடம் உள்ள தகவல் தாள் மற்றும் ஒப்புதல் படிவத்தில் கையெழுத்திட்டு அதன் நகலை நீங்கள் வைத்துக் கொள்ளவும். ")])]),_c('br')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HindiParticipationInfo_vue__ = __webpack_require__(30);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39075a4b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HindiParticipationInfo_vue__ = __webpack_require__(115);
function injectStyle (ssrContext) {
  __webpack_require__(114)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39075a4b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HindiParticipationInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39075a4b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HindiParticipationInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",attrs:{"id":"englishParticipationInfo"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box"},[_c('h1',{staticClass:"title has-text-centered"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("You are being invited to take part in this research study being conducted by the Schizophrenia Research Foundation (SCARF) and is led by Dr. R Thara. This is part of a programme on early identification and management of first-episode psychosis among school and college students.")]),_vm._v(" "),_c('p',[_vm._v("\n      Before you decide to take part, it is important for you to understand why the research is being done and what it will involve. Please take time to read the following information sheet carefully. Ask us if there is anything that is not clear or if you would like more information. Take time to\n      decide whether you wish to take part.\n    ")]),_vm._v(" "),_c('p',[_vm._v("Thank you for reading this.")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',[_vm._v("This study is designed to create a model of community awareness and early detection for youth mental health. Under this programme, a school based programme using community resources such as teachers, peers and youth groups will be piloted.")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('p',[_vm._v("\n      You have been invited to take part because you are a student at a school or college in the project area. Your participation in this study will help us better understand the mental health issues faced by young people. This will enable us to develop strategies and address the emerging issues\n      on mental health.\n    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('p',[_vm._v("It is up to you to decide whether to take part. If you do decide to take part you will be given this information sheet to keep and will be asked to sign a consent form. If you decide to take part you are still free to withdraw at any time, without giving a reason.")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('p',[_vm._v("\n      If you choose to participate you will likely benefit by understanding your own mental health better. There is an indirect benefit that the findings from this study will ultimately contribute to our better understanding of mental health and disorders in the youth and it will lead to the\n      improvement of mental health for young people.\n    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('p',[_vm._v("You will be asked to answer a series of questions which are part of a screening test for mental health app. This will approximately take 15 minutes of your time. The information collected on this screening tool will assess your mental health status.")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('p',[_vm._v("Other than taking up some of your time, there are no disadvantages and risks involved in taking part in this study")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('p',[_vm._v("Yes. If you consent to take part in the research anything you say will be anonymised and both recordings and transcripts will be held securely.")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('p',[_vm._v("\n      The results of the study will be published in scientific or medical journals and presented at conferences. Copies of the published results will be available to you on request after the data collection is finished and the analyses have been performed. Your name will not be linked to the\n      publications in any way.\n    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('p',[_vm._v("This study is being carried out by researchers at SCARF in collaboration with University of Warwick. The study is funded by the National Institute of Health Research, UK.")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('p',[_vm._v("An ethics committee has reviewed the study for compliance with medical and ethical standards and for scientific value.")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('p',[_vm._v("Whenever you want to get more information on this study, please contact:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Dr. R. Thara")]),_vm._v(" "),_c('p',[_vm._v("Address: SCARF, Mental Health centre, R/7A, North Main Road, Anna Nagar, West Extension,")]),_vm._v(" "),_c('p',[_vm._v("Ch-101")]),_vm._v(" "),_c('p',[_vm._v("Tel:044 26153971, E-mail: thara@scarfindia.org")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("If you have complaints regarding the conduct of the study please contact:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Dr. Lakshmi Vijaykumar")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Chairperson, IEC of SCARF,")]),_vm._v(" "),_c('p',[_vm._v("SCARF, Mental Health Centre, R/7A, North Main Road, Anna Nagar, West Extension, Chennai")]),_vm._v(" "),_c('p',[_vm._v("-600101")]),_vm._v(" "),_c('p',[_vm._v("Tel: 24981939")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('br')])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/consent-form-hindi"}},[_c('i',{staticClass:"fa fa-arrow-left"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"has-text-centered"},[_c('b',[_vm._v("NIHR Global Health Research Group on Psychosis outcome: Warwick-India-Canada (WIC) Network")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"has-text-centered"},[_c('b',[_vm._v("SCARF commissioned study - School and college based interventions for early detection and referral of adolescent and young individuals with psychosis")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHAT IS THE PURPOSE OF THE STUDY?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHY HAVE I BEEN INVITED TO TAKE PART?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("DO I HAVE TO TAKE PART?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHAT WILL HAPPEN TO ME IF I TAKE PART?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHAT IS THE STUDY PROCEDURE?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHAT ARE THE POSSIBLE DISADVANTAGES AND RISKS OF TAKING PART?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WILL MY TAKING PART IN THIS STUDY BE KEPT CONFIDENTIAL?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHAT WILL HAPPEN TO THE RESULTS OF THE RESEARCH STUDY?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHO IS ORGANISING AND FUNDING THE RESEARCH?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHO HAS REVIEWED THE STUDY?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("CONTACT FOR FURTHER INFORMATION")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("Thank you for considering taking part in this study. You will be given a copy of the information sheet and a signed consent form to keep.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarathiParticipationInfo_vue__ = __webpack_require__(31);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_441ed60b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarathiParticipationInfo_vue__ = __webpack_require__(118);
function injectStyle (ssrContext) {
  __webpack_require__(117)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-441ed60b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarathiParticipationInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_441ed60b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarathiParticipationInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",attrs:{"id":"englishParticipationInfo"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box"},[_c('h1',{staticClass:"title has-text-centered"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("You are being invited to take part in this research study being conducted by the Schizophrenia Research Foundation (SCARF) and is led by Dr. R Thara. This is part of a programme on early identification and management of first-episode psychosis among school and college students.")]),_vm._v(" "),_c('p',[_vm._v("\n      Before you decide to take part, it is important for you to understand why the research is being done and what it will involve. Please take time to read the following information sheet carefully. Ask us if there is anything that is not clear or if you would like more information. Take time to\n      decide whether you wish to take part.\n    ")]),_vm._v(" "),_c('p',[_vm._v("Thank you for reading this.")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',[_vm._v("This study is designed to create a model of community awareness and early detection for youth mental health. Under this programme, a school based programme using community resources such as teachers, peers and youth groups will be piloted.")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('p',[_vm._v("\n      You have been invited to take part because you are a student at a school or college in the project area. Your participation in this study will help us better understand the mental health issues faced by young people. This will enable us to develop strategies and address the emerging issues\n      on mental health.\n    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('p',[_vm._v("It is up to you to decide whether to take part. If you do decide to take part you will be given this information sheet to keep and will be asked to sign a consent form. If you decide to take part you are still free to withdraw at any time, without giving a reason.")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('p',[_vm._v("\n      If you choose to participate you will likely benefit by understanding your own mental health better. There is an indirect benefit that the findings from this study will ultimately contribute to our better understanding of mental health and disorders in the youth and it will lead to the\n      improvement of mental health for young people.\n    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('p',[_vm._v("You will be asked to answer a series of questions which are part of a screening test for mental health app. This will approximately take 15 minutes of your time. The information collected on this screening tool will assess your mental health status.")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('p',[_vm._v("Other than taking up some of your time, there are no disadvantages and risks involved in taking part in this study")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('p',[_vm._v("Yes. If you consent to take part in the research anything you say will be anonymised and both recordings and transcripts will be held securely.")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('p',[_vm._v("\n      The results of the study will be published in scientific or medical journals and presented at conferences. Copies of the published results will be available to you on request after the data collection is finished and the analyses have been performed. Your name will not be linked to the\n      publications in any way.\n    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('p',[_vm._v("This study is being carried out by researchers at SCARF in collaboration with University of Warwick. The study is funded by the National Institute of Health Research, UK.")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('p',[_vm._v("An ethics committee has reviewed the study for compliance with medical and ethical standards and for scientific value.")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('p',[_vm._v("Whenever you want to get more information on this study, please contact:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Dr. R. Thara")]),_vm._v(" "),_c('p',[_vm._v("Address: SCARF, Mental Health centre, R/7A, North Main Road, Anna Nagar, West Extension,")]),_vm._v(" "),_c('p',[_vm._v("Ch-101")]),_vm._v(" "),_c('p',[_vm._v("Tel:044 26153971, E-mail: thara@scarfindia.org")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("If you have complaints regarding the conduct of the study please contact:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Dr. Lakshmi Vijaykumar")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Chairperson, IEC of SCARF,")]),_vm._v(" "),_c('p',[_vm._v("SCARF, Mental Health Centre, R/7A, North Main Road, Anna Nagar, West Extension, Chennai")]),_vm._v(" "),_c('p',[_vm._v("-600101")]),_vm._v(" "),_c('p',[_vm._v("Tel: 24981939")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('br')])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/consent-form-marathi"}},[_c('i',{staticClass:"fa fa-arrow-left"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"has-text-centered"},[_c('b',[_vm._v("NIHR Global Health Research Group on Psychosis outcome: Warwick-India-Canada (WIC) Network")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"has-text-centered"},[_c('b',[_vm._v("SCARF commissioned study - School and college based interventions for early detection and referral of adolescent and young individuals with psychosis")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHAT IS THE PURPOSE OF THE STUDY?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHY HAVE I BEEN INVITED TO TAKE PART?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("DO I HAVE TO TAKE PART?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHAT WILL HAPPEN TO ME IF I TAKE PART?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHAT IS THE STUDY PROCEDURE?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHAT ARE THE POSSIBLE DISADVANTAGES AND RISKS OF TAKING PART?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WILL MY TAKING PART IN THIS STUDY BE KEPT CONFIDENTIAL?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHAT WILL HAPPEN TO THE RESULTS OF THE RESEARCH STUDY?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHO IS ORGANISING AND FUNDING THE RESEARCH?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("WHO HAS REVIEWED THE STUDY?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("CONTACT FOR FURTHER INFORMATION")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("Thank you for considering taking part in this study. You will be given a copy of the information sheet and a signed consent form to keep.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",attrs:{"id":"summary"}},[_c('div',{staticClass:"box"},[_c('h1',{staticClass:"title"},[_vm._v("Response Submission")]),_vm._v(" "),(_vm.testId === 2)?_c('div',[_c('p',[_vm._v("Submit your response and check your results.")]),_vm._v(" "),_c('button',{staticClass:"button is-large",class:{ 'is-loading': _vm.isLoadingSubmit },attrs:{"disabled":_vm.isResultSubmitted},on:{"click":function($event){_vm.submitYourResponse()}}},[_vm._v("Submit")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('SessionInfo'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Thanks for taking the tests. Please click the button below to check your results.")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.isResultSubmitted)?_c('div',{staticClass:"has-text-centered"},[_c('button',{staticClass:"button is-info is-medium",on:{"click":function($event){_vm.checkResults()}}},[_vm._v("Check My Results")])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.testId === 3)?_c('div',[_c('p',[_vm._v("பதில்களின் பதிவு: உங்கள் பதில்களின் முடிவுகளை தெரிந்துகொள்ள கீழேயுள்ள சப்மிட் பட்டன்னை கிளிக் செய்யவும்")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button is-large",class:{ 'is-loading': _vm.isLoadingSubmit },attrs:{"disabled":_vm.isResultSubmitted},on:{"click":function($event){_vm.submitYourResponse()}}},[_vm._v("Submit")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('SessionInfo'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Thanks for taking the tests. Please click the button below to check your results.")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.isResultSubmitted)?_c('div',{staticClass:"has-text-centered"},[_c('button',{staticClass:"button is-info is-large",on:{"click":function($event){_vm.checkResults()}}},[_vm._v("முடிவுகளை தெரிந்துகொள்ளுங்கள்")])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.testId === 6)?_c('div',[_c('p',[_vm._v("Submit your response and check your results.")]),_vm._v(" "),_c('button',{staticClass:"button is-large",class:{ 'is-loading': _vm.isLoadingSubmit },attrs:{"disabled":_vm.isResultSubmitted},on:{"click":function($event){_vm.submitYourResponse()}}},[_vm._v("Submit")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('SessionInfo'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Thanks for taking the tests. Please click the button below to check your results.")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.isResultSubmitted)?_c('div',{staticClass:"has-text-centered"},[_c('button',{staticClass:"button is-info is-medium",on:{"click":function($event){_vm.checkResults()}}},[_vm._v("Check My Results")])]):_vm._e()],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tests_vue__ = __webpack_require__(34);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8336186e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tests_vue__ = __webpack_require__(123);
function injectStyle (ssrContext) {
  __webpack_require__(122)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8336186e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tests_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8336186e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tests_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.questionairAttended)?_c('div',[_c('Summary',{attrs:{"response":_vm.responses,"question":_vm.questions}})],1):_c('div',{staticClass:"section is-small",attrs:{"id":"questionAnswer"}},[(_vm.isLoading)?_c('div',[_vm._v("\n    Loading...\n    "),_c('i',{staticClass:"fa fa-spinner fa-2x"})]):_c('div',[_c('progress',{staticClass:"progress is-success",attrs:{"max":"100"},domProps:{"value":_vm.progressPercent}}),_vm._v(" "),_c('div',{staticClass:"is-size-6 has-text-centered"},[_vm._v(_vm._s(_vm.quesInfo))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"is-size-6 has-text-centered"},[_c('b',[_vm._v(_vm._s(_vm.question))])]),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.isSubQuestion)?_c('div',{staticClass:"columns is-multiline is-mobile"},_vm._l((_vm.options),function(option,index){return _c('div',{key:("o" + index),staticClass:"column is-6 has-text-centered is-outlined"},[_c('a',{staticClass:"button",on:{"click":function($event){_vm.updateResponse(index)}}},[_vm._v(_vm._s(option))])])})):_c('div',{staticClass:"columns is-multiline is-mobile"},_vm._l((_vm.options),function(option,index){return _c('div',{key:("o1" + index),staticClass:"column is-6 has-text-centered is-outlined"},[_c('a',{staticClass:"button disable",attrs:{"disabled":""}},[_vm._v(_vm._s(option))])])})),_vm._v(" "),(_vm.isSubQuestion)?_c('div',{staticClass:"card column"},[_c('div',{staticClass:"is-size-6 has-text-centered"},[_c('b',[_vm._v(_vm._s(_vm.subQuestion))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"columns is-multiline is-mobile"},_vm._l((_vm.subOptions),function(option,index){return _c('div',{key:("o2" + index),staticClass:"column is-6 has-text-centered is-outlined"},[_c('a',{staticClass:"button",on:{"click":function($event){_vm.updateResponseSubQuestion(index)}}},[_vm._v(_vm._s(option))])])}))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"columns is-gapless is-mobile"},[_c('div',{staticClass:"column has-text-centered"},[_c('a',{staticClass:"tc-button has-text-centered notification is-normal",attrs:{"disabled":_vm.index <= 0},on:{"click":function($event){_vm.showPrevQuesOptions(_vm.index - 1)}}},[_vm._v("< Previous")])])]),_vm._v(" "),_c('br')])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",attrs:{"id":"results"}},[(_vm.isLoading)?_c('div',[_vm._v("\n    Loading...\n    "),_c('i',{staticClass:"fa fa-spinner fa-2x"})]):_c('div',[_c('h1',{staticClass:"title"},[_vm._v("Your test results")]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"tc-card column tc-is-one-third"},[_c('div',{staticClass:"card-content"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"is-size-4"},[_c('b',[_vm._v(_vm._s(_vm.testResults.phq9Result.severity))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"is-4"},[_vm._v(_vm._s(_vm.testResults.phq9Result.description))])])])]),_vm._v(" "),_c('div',{staticClass:"tc-card column tc-is-one-third"},[_c('div',{staticClass:"card-content"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"is-size-4"},[_c('b',[_vm._v(_vm._s(_vm.testResults.gad7Result.severity))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"is-4"},[_vm._v(_vm._s(_vm.testResults.gad7Result.description))])])])]),_vm._v(" "),_c('div',{staticClass:"tc-card column tc-is-one-third"},[_c('div',{staticClass:"card-content"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"is-size-4"},[_c('b',[_vm._v(_vm._s(_vm.testResults.cape15Result.testSeverity))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"is-4",domProps:{"innerHTML":_vm._s(_vm.testResults.cape15Result.description)}})])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Thank you taking the tests. Wish you the best.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("This is a project by TrustCircle & SCARF.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckResults_vue__ = __webpack_require__(37);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93c3469a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckResults_vue__ = __webpack_require__(128);
function injectStyle (ssrContext) {
  __webpack_require__(127)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-93c3469a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckResults_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93c3469a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckResults_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",attrs:{"id":"checkResults"}},[_c('h1',{staticClass:"title"},[_vm._v("Check your results")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sessionCode),expression:"sessionCode"}],staticClass:"input",attrs:{"type":"text","placeholder":"Enter your result Id"},domProps:{"value":(_vm.sessionCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sessionCode=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"is-danger help"},[_vm._v(_vm._s(_vm.error.sessionCode))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Language")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.languageId),expression:"languageId"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.languageId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":"0"}},[_vm._v("-- Select --")]),_vm._v(" "),_vm._l((_vm.languages),function(language){return _c('option',{key:language.id,domProps:{"value":language.id}},[_vm._v("\n            "+_vm._s(language.name)+"\n          ")])})],2),_vm._v(" "),_c('p',{staticClass:"is-danger help"},[_vm._v(_vm._s(_vm.error.language))])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"control"},[(_vm.canGetResult)?_c('button',{staticClass:"button is-info",class:{ 'is-loading': _vm.isLoading },on:{"click":_vm.getSession}},[_vm._v("\n      Get Result\n    ")]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.isTestResultVisible)?_c('div',[_c('Results')],1):_vm._e(),_vm._v(" "),_c('br')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageSelection_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16131dfe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageSelection_vue__ = __webpack_require__(131);
function injectStyle (ssrContext) {
  __webpack_require__(130)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16131dfe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageSelection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16131dfe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageSelection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",attrs:{"id":"languageSelection"}},[_c('h1',{staticClass:"title"},[_vm._v("Select a Language")]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('br'),_vm._v(" "),_c('a',{staticClass:"card-footer-item"},[_c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-info",class:{ 'is-loading': _vm.isLoadingTamil },on:{"click":function($event){_vm.sendRequest('Tamil')}}},[_vm._v("Tamil")])])]),_vm._v(" "),_c('a',{staticClass:"card-footer-item"},[_c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-info",class:{ 'is-loading': _vm.isLoadingEnglish },on:{"click":function($event){_vm.sendRequest('English')}}},[_vm._v("English")])])]),_vm._v(" "),_c('a',{staticClass:"card-footer-item"},[_c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-info",class:{ 'is-loading': _vm.isLoadingHindi },on:{"click":function($event){_vm.sendRequest('Hindi')}}},[_vm._v("Hindi")])])]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('br'),_c('br')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(39);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c18fdc9a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(161);
function injectStyle (ssrContext) {
  __webpack_require__(133)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c18fdc9a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c18fdc9a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",attrs:{"id":"login"}},[_c('div',{staticClass:"title"},[_vm._v("Login")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Alias")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.alias),expression:"alias"}],staticClass:"input",attrs:{"type":"text","placeholder":"Enter an Alias name"},domProps:{"value":(_vm.alias)},on:{"input":function($event){if($event.target.composing){ return; }_vm.alias=$event.target.value}}})]),_vm._v(" "),_c('p',{staticClass:"is-danger help"},[_vm._v(_vm._s(_vm.error.alias))]),_vm._v(" "),_c('label',{staticClass:"label"},[_vm._v("Password")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"input",attrs:{"type":"password","placeholder":"Enter password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('p',{staticClass:"is-danger help"},[_vm._v(_vm._s(_vm.error.password))]),_vm._v(" "),_c('span',{staticClass:"has-text-danger"},[_vm._v(_vm._s(_vm.msgLoginError))])]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-info",class:{"is-loading": _vm.isLoading},on:{"click":_vm.submitLogin}},[_vm._v("Login")])]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('a',{attrs:{"href":"/forgot-password"}},[_vm._v("Forgot Password/Alias?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__ = __webpack_require__(45);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32aa14c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__ = __webpack_require__(164);
function injectStyle (ssrContext) {
  __webpack_require__(163)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32aa14c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32aa14c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",attrs:{"id":"forgotPassword"}},[_c('div',{staticClass:"title"},[_vm._v("Change Password")]),_vm._v(" "),_c('label',{staticClass:"label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"input",attrs:{"type":"text","placeholder":"Enter email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('p',{staticClass:"is-danger help"},[_vm._v(_vm._s(_vm.error.email))]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-info",class:{"is-loading": _vm.isLoading},on:{"click":_vm.submitForgotPassword}},[_vm._v("Send Reset Email")])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.msg)?_c('div',{staticClass:"notification is-info"},[_vm._v(_vm._s(_vm.msg))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Data_vue__ = __webpack_require__(46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72369b92_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Data_vue__ = __webpack_require__(167);
function injectStyle (ssrContext) {
  __webpack_require__(166)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72369b92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Data_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72369b92_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Data_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section",attrs:{"id":"getData"}},[_c('div',{staticClass:"title"},[_vm._v("Data Export")]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Select School / College")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"select",class:{"is-loading": _vm.isOrgsLoading}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.orgId),expression:"orgId"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.orgId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","value":"0"}},[_vm._v("-- Select --")]),_vm._v(" "),_vm._l((_vm.orgs),function(org){return _c('option',{domProps:{"value":org.id}},[_vm._v(_vm._s(org.name))])})],2)])])]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-info",class:{"is-loading": _vm.isLoading},on:{"click":function($event){_vm.getData()}}},[_vm._v("Export Data")])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.msg)?_c('div',{staticClass:"notification is-info"},[_vm._v(_vm._s(_vm.msg))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8e5daca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(170);
function injectStyle (ssrContext) {
  __webpack_require__(169)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d8e5daca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8e5daca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",attrs:{"id":"dashboard"}},[_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Total Screenings")]),_vm._v(": "+_vm._s(_vm.countTotal)+"\n  "),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"card column year2018"},[_c('div',{staticClass:"card-content"},[_vm._m(1),_vm._v("\n        Number of Screenings: "+_vm._s(this.count2018)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"card column year2019"},[_c('div',{staticClass:"card-content"},[_vm._m(2),_vm._v("\n        Number of Screenings: "+_vm._s(this.count2019)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"card column year2020"},[_c('div',{staticClass:"card-content"},[_vm._m(3),_vm._v("\n        Number of Screenings: "+_vm._s(this.count2020)+"\n      ")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},_vm._l((_vm.quarters),function(quarter){return _c('div',{key:quarter.name,staticClass:"card column is-6 quarter"},[_c('div',{staticClass:"card-content"},[_c('h3',{staticClass:"is-size-5"},[_c('b',[_vm._v(_vm._s(quarter.name))])]),_vm._v("\n        Number of Screenings: "+_vm._s(quarter.count)+"\n        "),(quarter.remarks)?_c('div'):_vm._e()])])})),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},_vm._l((_vm.quarters2020),function(quarter){return _c('div',{key:quarter.name,staticClass:"card column is-6 quarter"},[_c('div',{staticClass:"card-content"},[_c('h3',{staticClass:"is-size-5"},[_c('b',[_vm._v(_vm._s(quarter.name))])]),_vm._v("\n        Number of Screenings: "+_vm._s(quarter.count)+"\n        "),(quarter.remarks)?_c('div'):_vm._e()])])})),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},_vm._l((_vm.orgs),function(org){return _c('div',{key:org,staticClass:"card column is-6 org"},[_c('div',{staticClass:"card-content"},[_vm._v("\n        "+_vm._s(org)+"\n      ")])])}))])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-size-4"},[_c('b',[_vm._v("Wellbeing Assessments for Schools/Colleges")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"is-size-5"},[_c('b',[_vm._v("2018")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"is-size-5"},[_c('b',[_vm._v("2019")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"is-size-5"},[_c('b',[_vm._v("2020")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"is-size-4"},[_c('b',[_vm._v("2019")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"is-size-4"},[_c('b',[_vm._v("2020")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"is-size-4"},[_c('b',[_vm._v("Schools/Colleges Attended")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[48]);


// WEBPACK FOOTER //
// static/js/app.fad6f8bec140a39b40e4.js